import CustomCheckbox from "components/Atoms/CustomCheckbox"
import React from "react"
import { useTaskSelector } from "./interfaces"
const TaskSelectorAll = () => {
  const [isSelected, toggleSelectAll] = useTaskSelector(store => [
    store.selectAll(),
    store.toggleSelectAll,
  ])
  return <CustomCheckbox checked={isSelected} onChange={toggleSelectAll} />
}

export default TaskSelectorAll
